const cn = (...classes: string[]) => classes.filter(Boolean).join(' ');

export default cn;
